import { useEffect } from "react";

/** Community partners — open externally per prototype `.partner-links`. */
const PARTNERS = [
  {
    name: "Savage Roasters",
    href: "https://savageroasters.com/",
    blurb: "Small-batch coffee roasters fueling the Bullet.",
    testid: "partner-savage-roasters",
  },
  {
    name: "Dream Kreams",
    href: "https://www.dreamkreams.com/",
    blurb: "Hand-crafted ice cream and frozen treats.",
    testid: "partner-dream-kreams",
  },
];

/**
 * Partners — Public partners page (SPR-018 C-03).
 *
 * Lists the truck's community partners as cards/buttons that open the partner
 * sites in a new tab. Served at /partners; linked from the public footer.
 *
 * Static content styled per BLU-006 (font-heading/font-body, charcoal/cream/teal).
 */
export default function Partners() {
  useEffect(() => {
    const previous = document.title;
    document.title = "Partners — Twin City Silver Bullet";
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <main
      data-testid="partners-page"
      className="min-h-screen bg-cream text-ink font-body"
    >
      <section className="max-w-3xl mx-auto px-4 py-16">
        <p className="font-heading tracking-[0.3em] text-teal-deep text-sm">
          WHO WE ROLL WITH
        </p>
        <h1 className="font-display text-5xl text-charcoal uppercase mb-6">
          Our Partners
        </h1>

        <p className="font-body text-ink/80 text-lg leading-relaxed mb-10">
          The Silver Bullet runs on great local partners. Show them some love.
        </p>

        <div className="space-y-5" data-testid="partner-links">
          {PARTNERS.map((partner) => (
            <a
              key={partner.href}
              href={partner.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={partner.testid}
              className="block bg-cream-deep border-2 border-dashed border-aluminum-dark rounded-2xl p-6 hover:border-teal hover:translate-y-0.5 transition-all"
            >
              <h2 className="font-display text-2xl text-charcoal uppercase mb-1">
                {partner.name}
              </h2>
              <p className="font-body text-ink/70">{partner.blurb}</p>
              <span className="inline-block mt-3 font-heading tracking-widest text-sm text-teal">
                VISIT SITE →
              </span>
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}
